export const USER_STATUS = Object.freeze({
  SAVED: "SAVED",
  INVITED: "INVITED",
  INCOMPLETE: "INCOMPLETE",
  REGISTERED: "REGISTERED",
});

export const usersStatusesAllowsInvite = [
  USER_STATUS.SAVED,
  USER_STATUS.INVITED,
  USER_STATUS.INCOMPLETE,
];

export const USER_STATUS_THEME = Object.freeze({
  [USER_STATUS.SAVED]: "gray",
  [USER_STATUS.INVITED]: "green",
  [USER_STATUS.INCOMPLETE]: "red",
  [USER_STATUS.REGISTERED]: "blue",
});

export const USER_STATUS_TO_UI_ENUM = Object.freeze({
  [USER_STATUS.SAVED]: "User Added",
  [USER_STATUS.INVITED]: "Invite Sent",
  [USER_STATUS.INCOMPLETE]: "Disabled",
  [USER_STATUS.REGISTERED]: "Active",
});

export const USER_ROLE = Object.freeze({
  1: "Manger",
  2: "Member",
  3: "Admin",
  4: "Finance",
  6: "Developer",
  7: "End User",
  8: "Coach",
  9: "System Executor",
});

export const REVERSED_USER_ROLE = Object.fromEntries(
  Object.entries(USER_ROLE).map(([key, value]) => [value, key]),
);
